import BaseService from './BaseService';
import { IChangeLocationResponse, IFetchMapResponse, IMapService } from 'types/map';

class MapService extends BaseService implements IMapService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetch = () => {
    const config = {
      url: 'map',
    };
    return this.doRequest<IFetchMapResponse>(config);
  };

  /**
   * Change location
   * @param  {Number} areaId
   * @return {Promise}
   */
  changeLocation = (areaId: number) => {
    const config = {
      method: 'post',
      url: 'map/move',
      data: { areaId }
    };
    return this.doRequest<IChangeLocationResponse>(config);
  };
}

export { MapService as default };
